/*
 * Copyright (c) 2020. Minerva Networks.
 * All rights reserved.
 */

/* eslint-disable global-require,import/no-dynamic-require */

import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login.vue';
import Login2 from '@/components/Login2.vue';
import Payment from '@/components/Payment.vue';
import Clean from '@/components/Clean.vue';
import Home from '@/components/Home.vue';
import Faq from '@/components/Faq.vue';
import Rds from '@/components/RDS.vue';

const IdentityProvider = resolve => require(['@/components/IdentityProvider'], resolve);
const PaymentError = resolve => require(['@/components/PaymentError'], resolve);
const Unavailable = resolve => require(['@/components/Unavailable'], resolve);
const Paywall = resolve => require(['@/components/PayWall'], resolve);
const Logout = resolve => require(['@/components/Logout'], resolve);
const Redeem = resolve => require(['@/components/Redeem'], resolve);
const Ticket = resolve => require(['@/components/Ticket'], resolve);
const Privacy = resolve => require(['@/components/Privacy'], resolve);
// const Mobile = resolve => require(['@/components/Mobile'], resolve);

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    /*
    {
      path: '/mobile',
      name: 'Home',
      component: Mobile,
    },
    */
    {
      path: '/rds',
      name: 'rds',
      component: Rds,
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/clean',
      name: 'clean',
      component: Clean,
    },
    {
      path: '/unavailable',
      name: 'Unavailable',
      component: Unavailable,
    },
    {
      path: '/widget',
      name: 'Widget',
      redirect: '/',
    },
    {
      path: '/paymentError/:item',
      name: 'PaymentError',
      component: PaymentError,
      props: true,
    },
    {
      path: '/faq',
      name: 'Faq',
      component: Faq,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/login2',
      name: 'Login2',
      component: Login2,
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
    },
    {
      path: '/paywall',
      name: 'PayWall',
      component: Paywall,
    },
    {
      path: '/redeem',
      name: 'Redeem',
      component: Redeem,
    },
    {
      path: '/ticket',
      name: 'Ticket',
      component: Ticket,
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
    },
    {
      path: '/payment',
      name: 'Payment',
      component: Payment,
      props: true,
    },
    {
      path: '/ip',
      name: 'IdentityProvider',
      component: IdentityProvider,
    },
    {
      path: '/video/:vid',
      name: 'Video',
      component: Home,
      props: true,
    },
  ],
});
